import classNames from 'classnames';
import { ISnowStatus } from 'api/resort/types';
import { SnowUnit } from 'components/blocks/Unit';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

import styles from './styles.module.scss';

const RecentSnowfall = ({ snow }: { snow: ISnowStatus }) => {
  const { t } = useOTSTranslation('common');

  return (
    <div className={styles.item}>
      <div className={styles.itemHeader}>
        <span className={classNames('h4', styles.h4)}>
          {t('resort.skiReport.recentSnowfall')}
        </span>
      </div>
      <div className={styles.cols}>
        {!!snow.last24 && (
          <div>
            <span className={classNames('h4', styles.h4)} title={t('resort.skiReport.24hSnowfall')}>
              <SnowUnit values={snow.last24} />
            </span>
            <span>{t('resort.skiReport.24hSnowfall')}</span>
          </div>
        )}
        {!!snow.last72 && (
          <div>
            <span className={classNames('h4', styles.h4)} title={t('resort.skiReport.72hSnowfall')}>
              <SnowUnit values={snow.last72} />
            </span>
            <span>{t('resort.skiReport.72hSnowfall')}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecentSnowfall;
